import { UserDto } from "../../../types/user/user-dto";
import { convertUserDtoToUser } from "../../../utils/converter/user/user-converter";
import { ProfileState } from "../../type/profile-state";

interface Action {
  type: string;
  payload: {
    userDto: UserDto;
  };
}

export const getMeDispatch = (state: ProfileState, action: Action) => {
  const { userDto } = action.payload;
  state.profile = convertUserDtoToUser(userDto);
  state.isLoggedIn = true;
};
